import background from "../../assets/images/background.png";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import { useEffect, useState } from "react";
import { DASHBOARD_ROUTE } from "../../routes";
import { Link } from "react-router-dom";

const SucessPage = ({history}) => {

    const [countDown, setCountDown] = useState(5);
    let count = 5 ;
    let timer ;
    useEffect(()=>{
        timer = setInterval(()=>{
            count--;
            if(count<=0) {
                // redirect to home
                history.replace(DASHBOARD_ROUTE)
                clearInterval(timer);
            }
            setCountDown(count)
        },1000)

        return (()=>{
            clearInterval(timer);
        })
    },[])

    return ( 
        <div id="sucess-page" style={{
            backgroundImage: `url(${background})`,
            minHeight: "100vh",
        }}>
            <div className="container pb-5">
                <div className="btn mt-3">
                    
                </div>
                <h1 className="text-center text-light mt-5">Payment Successful!</h1>
                <h5 className="text-center text-light mt-5">Please wait while we redirect you to the dashboard… Or you can manually click the below button to navigate to you dashboard.</h5>
                <div className="text-center text-light mt-5">Redirecting to Dashboard in {countDown}s </div>
                <div className="text-center mt-3">
                    <Link className="text-center text-light mt-5" to={DASHBOARD_ROUTE}>Go to Dashboard</Link>
                </div>
            </div>
        </div> 
    );
}
 
export default SucessPage;